var _path, _g, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBixinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 39,
    viewBox: "0 0 140 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4099_1319",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.355469 0.37793H38.7151V38.7797H0.355469V0.37793Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4099_1319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5221 33.1648L23.2737 29.7227H16.0626C13.5692 29.7227 11.5482 27.7015 11.5482 25.2081V21.3116C11.5482 18.8182 13.5692 16.797 16.0626 16.797H23.0073C25.5007 16.797 27.5221 18.8182 27.5221 21.3116V33.1648ZM26.8431 7.74021H11.5427C11.5427 3.6742 8.24686 0.37793 4.18062 0.37793H0.355469V7.74021V11.3538V26.9079C0.355469 33.4646 5.67077 38.7799 12.2273 38.7799H26.8431C33.3998 38.7799 38.7151 33.4646 38.7151 26.9079V19.6122C38.7151 13.0555 33.3998 7.74021 26.8431 7.74021Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.707 30.0136H81.36V9.88477H77.707V30.0136Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.092 9.88477H98.5209L93.7998 16.4738L89.0574 9.88477H84.5127L91.5422 19.582L83.951 30.0136H88.5284L93.8024 22.6493L99.0765 30.0136H103.654L96.0626 19.582L103.092 9.88477Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.384 30.0136H110.037V9.88477H106.384V30.0136Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.94 9.36523V24.1096L117.762 9.36523H114.688V30.065H118.39V15.2264L136.616 30.065H139.642V9.36523H135.94Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3086 24.427C69.3086 25.4751 68.4589 26.325 67.4104 26.325H51.9584V13.093H66.1111C66.2899 13.093 66.4798 13.093 66.6709 13.0928C67.6915 13.0923 68.5188 13.9194 68.519 14.9399V15.7036C68.5192 16.7237 67.6919 17.551 66.6716 17.551H66.428H58.8573L63.4823 21.2912H67.4108C68.4589 21.2912 69.3086 22.1409 69.3086 23.189V24.427ZM71.3934 18.9711L71.3581 18.9381L71.3854 18.8986C71.9884 18.0199 72.2815 17.0446 72.2815 16.1197V14.8275C72.2815 14.6677 72.2818 14.4863 72.282 14.2891C72.2874 11.5654 70.0802 9.35373 67.3568 9.35303C67.1569 9.35303 66.9722 9.35303 66.8073 9.35303H48.2174V30.0648H67.9998C70.9759 30.0648 73.0789 27.921 73.0789 25.0302L73.0478 22.3586C73.0478 21.1943 72.4448 19.9596 71.3934 18.9711Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBixinLogo);
export default __webpack_public_path__ + "static/media/bixin_logo.214310068aaeaf9bc93e8ea26a3a4999.svg";
export { ForwardRef as ReactComponent };